@if (overridden) {
  <span class="override-enabled-text">
    {{'manual-override-box.enabled-message' | translate}}
  </span>
}
@if (!overridden) {
  <span>
    {{'manual-override-box.disabled-message' | translate}}
  </span>
}
<button gbc-text-button (click)="toggleManualOverride()"
  angulartics2On="click"
  angularticsAction="acknowledgeClicked"
  angularticsCategory="notificationClicked">
  {{overridden ? ('manual-override-box.disable-button' | translate) : ('manual-override-box.enable-button' | translate)}}
</button>
